module.exports = __webpack_public_path__ + "static/media/R2.8b52295c.jpg";